
    import './styles.scoped.css';
    export default {
  "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_4w5vn_5",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_4w5vn_14",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_4w5vn_17",
  "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_4w5vn_20"
};
  